import '@babel/polyfill'
import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import './plugins/vuetify'
import './plugins/axios'
import './plugins/config'
import './plugins/extensions'
import './plugins/notify'
import './plugins/others'

import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'

import 'vuetify/dist/vuetify.min.css'

import '@/css/app.styl'
import '@/css/notify.styl'
import '@/css/positioning.styl'

import './registerServiceWorker'

Vue.config.productionTip = false
Vue.config.keyCodes.f5 = 116

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
